import { createApp, h } from "vue";
import { setupCalendar, Calendar, DatePicker } from 'v-calendar';
import BookingsCalendar from "./components/BookingsCalendar.vue";

import 'v-calendar/dist/style.css';

const app = createApp({
    render: () => h(BookingsCalendar),
});

app.use(setupCalendar, {});

app.component('Calendar', Calendar)
app.component('DatePicker', DatePicker)

app.mount("#calendar");
